import { Component, OnInit, OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';

import { LoginViewEnum } from '../login-view.enum';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'signgaze-login-container',
  templateUrl: './login-container.component.html',
  styleUrls: ['./login-container.component.scss'],
})
export class LoginContainerComponent implements OnInit, OnDestroy {
  readonly subs = new SubSink();
  loginViewEnum: any = LoginViewEnum;
  currentView: LoginViewEnum;

  constructor(public loginService: LoginService) {}

  ngOnInit(): void {
    this.subs.sink = this.loginService.currentLoginView$.subscribe({
      next: (currentView: LoginViewEnum): void => {
        this.currentView = currentView;
      },
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public changeLoginView(currentLoginView: LoginViewEnum): void {
    this.loginService.currentLoginView$.next(currentLoginView);
  }
}
